import axios from 'axios';
import {SentactFeedbackHttpError} from "util/SentactFeedbackHttpError.js";

/**
 * Sentact Public API base url
 */
const publicApiBaseUrl = '/api/';

const axiosClient = axios.create({
    baseURL: publicApiBaseUrl,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }
});

/**
 * Send a GET request
 *
 * @param url           Url to hit
 * @param params        Request params
 *
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const get = (
    url,
    params={},
) => {
    return axiosClient.get(url, { params })
};

/**
 * Send a POST request
 *
 * @param url           Url to hit
 * @param data          Data to send
 * @param params        Request params
 *
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export const post = (url, data, params={}) => {
    return axiosClient.post(url, data, { params });
};

axiosClient.interceptors.response.use(
    response => {
        // if data doesn't exist, assume empty object
        return response?.data ?? {};
    },
    error => {
        if (error.response) {
            handleErrorResponse(error.response);
        } else if (error.request) {
            // no response, only request
            throw new SentactFeedbackHttpError('Network error');
        } else {
            // request set up is bad
            throw new SentactFeedbackHttpError('Request error');
        }
    }
)

const handleErrorResponse = (axiosErrorResponse) => {
    let code = axiosErrorResponse.status;
    let message = axiosErrorResponse.statusText;

    if (axiosErrorResponse.data?.error?.code) {
        code = axiosErrorResponse.data?.error?.code;
    }
    if (axiosErrorResponse.data?.error?.message) {
        message = axiosErrorResponse.data?.error?.message;
    }
    throw new SentactFeedbackHttpError(message, code);
}

const base = {
    get: get,
    post: post,
    publicApiBaseUrl: publicApiBaseUrl,
};

export default base;
